module.exports = __webpack_public_path__ + "static/img/RCB12V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RCB12V_1.png
// module id = AKbk
// module chunks = 0